<template>
  <v-navigation-drawer
    :model-value="modelValue"
    temporary
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-list nav density="comfortable">
      <v-list-item :title="authStore.appName" :subtitle="authStore.user?.username" />
      <v-divider class="my-2" />

      <v-list-item prepend-icon="mdi-book-open-variant" :title="$t('nav.quizzes')" @click="go('/')" />
      <v-list-item prepend-icon="mdi-account-circle" :title="$t('nav.profile')" @click="go('/profile')" />

      <template v-if="authStore.isAdmin">
        <v-divider class="my-2" />
        <v-list-subheader>{{ $t('nav.admin') }}</v-list-subheader>
        <v-list-item prepend-icon="mdi-account-group" :title="$t('nav.users')" @click="go('/users')" />
        <v-list-item prepend-icon="mdi-cog" :title="$t('nav.settings')" @click="go('/settings')" />
      </template>

      <v-divider class="my-2" />
      <v-list-item prepend-icon="mdi-logout" :title="$t('nav.logout')" @click="logout" />
    </v-list>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'

defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ 'update:modelValue': [boolean] }>()

const router = useRouter()
const authStore = useAuthStore()

function go(path: string) {
  emit('update:modelValue', false)
  router.push(path)
}

function logout() {
  emit('update:modelValue', false)
  authStore.logout()
  router.push('/login')
}
</script>
